import { useState, useEffect } from "react";

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="flex flex-col w-full">
      {/* Spacer to prevent content overlap */}
      <div
        className='transition-all duration-300'
        style={{
          height: isScrolled ? '60px' : '120px',
        }}
      />
      
      {/* Navbar Container - Added a wrapper div for proper centering */}
      <div className="fixed top-0 left-0 right-0 z-50 flex justify-center w-full">
        <div
          className={`transition-all duration-300 ${
            isScrolled
              ? 'w-3/4 max-md:w-10/12 max-sm:w-11/12 my-4 bg-slate-200/70 shadow-lg rounded-2xl'
              : 'w-full bg-slate-200 shadow-md'
          }`}
        >
          <div className="flex justify-center items-center py-3">
            <h1 className="text-xl md:text-3xl lg:text-4xl font-bold text-brown-700 font-heading">
              <a href="/">Sandhya Mulchandani</a>
            </h1>
          </div>
          
          <div
            className={`flex flex-wrap justify-center items-center lg:mt-3 md:mt-2 mt-1 pb-4 space-x-2 md:space-x-8 transition-opacity ${
              isScrolled ? 'opacity-90' : 'opacity-100'
            }`}
          >
            {['Events', 'Gallery', 'Classes', 'About', 'Contact'].map((link) => (
              <a
                key={link}
                href={link === 'Events' ? '/events' : `/#${link.toLowerCase()}Nav`}
                target={link === 'Events' ?'_blank' : undefined}
                className="lg:px-3 md:px-2 px-1 py-1 text-brown-600 text-sm md:text-lg font-semibold max-sm:font-normal rounded-lg transition-all shadow-inset hover:bg-beige/50 hover:shadow-md font-para"
              >
                {link}
              </a>
            ))}
            {!isScrolled && <a
              href='https://www.instagram.com/sandhyamulchandaniart'
              target='_blank'
              className="px-2 py-[7px] text-brown-600 text-sm md:text-lg font-medium rounded-lg transition-all shadow-inset hover:bg-beige/50 hover:shadow-md max-sm:hidden"
            >
              <img className='w-4 md:w-5' src='/images/instagram.png' alt='insta-logo' />
            </a>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;